module.exports = __webpack_public_path__ + "img/026-seo-and-web.8c5ed708.svg";